<template>
    <v-row no-gutters>
        <v-col cols="4" />
        <v-col cols="8">
            <v-data-table
                :headers="secondaryHeaders"
                :items="[company]"
                class="table elevation-0"
                fixed-header
                :items-per-page="-1"
                hide-default-footer
                v-if="company"
                density="compact"
            >
                <template v-slot:item="{ item }">
                    <tr>
                        <td class="text-left">
                            {{ item && item.shareCapital ? formatCapital(item.shareCapital) : "" }}
                        </td>
                        <td class="text-right">
                            {{ item && item.shareTotal ? item.shareTotal : "" }}
                        </td>
                        <td class="text-right">{{ shareNominalValue }}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-col>
        <v-col cols="12" v-if="associateUsers" class="pt-2">
            <v-data-table
                :headers="primaryHeaders"
                :items="associateUsers"
                class="table elevation-0"
                fixed-header
                :items-per-page="-1"
                hide-default-footer
                density="compact"
            >
                <template v-slot:item="props">
                    <tr>
                        <td class="text-left" />
                        <td class="text-left">{{ formatUserFirstname(props.item.user) }}</td>
                        <td class="text-left">{{ formatUserLastname(props.item.user) }}</td>
                        <td class="text-left">{{ formatUserType(props.item.user) }}</td>
                        <td class="text-right">
                            {{
                                props.item.investment.capitalShare
                                    ? props.item.investment.capitalShare
                                    : 0
                            }}
                        </td>
                        <td class="text-right">
                            {{ formatPercentage(props.item.investment.amount) }}
                        </td>
                    </tr>
                </template>
                <template v-slot:body.append>
                    <tr>
                        <td />
                        <td class="text-right" colspan="3"><strong>Total</strong></td>
                        <td class="text-right">{{ associateUsersTotalShares.shareQuantity }}</td>
                        <td class="text-right">
                            {{ associateUsersTotalShares.sharePercentage + " %" }}
                        </td>
                    </tr>
                    <tr :style="{ color: shareQuantityDifference !== 0 && 'red' }">
                        <td />
                        <td class="text-right" colspan="3"><strong>&#xc9;cart</strong></td>
                        <td class="text-right">{{ shareQuantityDifference }}</td>
                        <td class="text-right">{{ sharePercentageDifference }}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-col>
        <v-col cols="12" v-else class="pt-2">
            <div v-if="sciAssociateUsers && sciAssociateUsers.length">
                <v-data-table
                    :headers="sciHeaders"
                    :items="sciAssociateUsers"
                    class="table elevation-0"
                    fixed-header
                    :items-per-page="-1"
                    hide-default-footer
                    density="compact"
                >
                    <template v-slot:item="props">
                        <tr>
                            <!-- <td colspan="6"></td> -->
                            <td class="text-left">{{ formatUserFirstname(props.item.user) }}</td>
                            <td class="text-left">
                                {{ formatUserLastname(props.item.user.lastname) }}
                            </td>
                            <td class="text-left">{{ formatUserType(props.item.user) }}</td>
                            <td class="text-right">
                                <div
                                    v-for="(share, key) in props.item.investment.shares"
                                    :key="key"
                                    class="d-flex my-2"
                                >
                                    <span class="d-block text-right pl-2">{{
                                        share.date ? formatDate(share.date) : "-"
                                    }}</span>
                                    <span class="d-block text-right pl-2">{{
                                        share.quantity ? share.quantity : "-"
                                    }}</span>
                                    <span class="d-block text-right pl-2">{{
                                        share.amount ? share.amount + "&#x20ac;" : "-"
                                    }}</span>
                                    <span class="d-block text-right pl-2">{{
                                        share.percentage ? share.percentage + "%" : "-"
                                    }}</span>
                                </div>
                            </td>
                        </tr>
                    </template>
                    <template v-slot:body.append>
                        <tr>
                            <td colspan="3" />
                            <td class="text-left">
                                <strong>Total:</strong>
                                {{ sciAssociateUsersTotalShares.shareQuantity + "  "
                                }}{{ "  " + sciAssociateUsersTotalShares.sharePercentage + " %" }}
                            </td>
                            <!-- <td class="text-left" >{{ sciAssociateUsersTotalShares.shareQuantity }}</td> -->
                            <!-- <td class="text-left" >{{ sciAssociateUsersTotalShares.sharePercentage + " %" }}</td> -->
                        </tr>
                        <tr :style="{ color: sciShareQuantityDifference !== 0 && 'red' }">
                            <td colspan="3" />
                            <td class="text-left">
                                <strong>&#xc9;cart:</strong>
                                {{ sciShareQuantityDifference + "  " }}
                                {{ "  " + sciSharePercentageDifference }}
                            </td>
                            <!-- <td class="text-left">{{ sciShareQuantityDifference }}</td> -->
                            <!-- <td class="text-left">{{ sciSharePercentageDifference }}</td> -->
                        </tr>
                    </template>
                </v-data-table>
            </div>
        </v-col>
    </v-row>
</template>
<script lang="ts">
import moment from "moment-timezone";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {},
    emits: ["shareQuantityDifferenceIsOverZero"],
})
export class AssociatesTable extends Vue {
    @Prop({ default: null }) company!: any;

    get secondaryHeaders() {
        return [
            { title: "Capital social", value: "shareCapital", align: "left" },
            { title: "Nombre de parts", value: "shareTotal", align: "right" },
            { title: "Valeur nominale", value: "shareNominalValue", align: "right" },
        ];
    }

    get isSCI() {
        return this.company?.legalForm === "SCI";
    }

    get primaryHeaders() {
        return [
            { title: "", value: "" },
            { title: "Prénom", value: "firstname", align: "left" },
            { title: "Nom", value: "lastname", align: "left" },
            { title: "Type", value: "type", align: "left" },
            { title: "Nombre de parts", value: "capitalShare", align: "right" },
            { title: "Pourcentage de détention", value: "amount", align: "right" },
        ];
    }

    get sciHeaders() {
        return [
            // {title: "", value:""},
            { title: "Prénom", value: "user.firstname", align: "left" },
            { title: "Nom", value: "user.lastname", align: "left" },
            { title: "Type", value: "user.type", align: "left" },
            {
                title: "Parts (Date, Quantité, Montant, Détention)",
                value: "investment.shares",
                align: "left",
                sortable: false,
            },
        ];
    }

    get shareCapital() {
        return this.company?.shareCapital || "";
    }

    get shareTotal() {
        return this.company?.shareTotal || "";
    }

    get shareNominalValue() {
        let total = 0;

        if (this.shareTotal && this.shareCapital) {
            total = this.shareCapital / this.shareTotal;

            return total.toFixed(2);
        }

        return "";
    }

    get shareQuantityDifference() {
        // Compare la somme des parts des associés avec le nombre total de parts de la société
        let total = 0;
        if (this.shareTotal && this.associateUsersTotalShares.shareQuantity) {
            total = this.shareTotal - this.associateUsersTotalShares.shareQuantity;
        }
        if (total !== 0) {
            this.$emit("shareQuantityDifferenceIsOverZero");
        }
        return total;
    }

    get sharePercentageDifference() {
        // Compare la somme des pourcentages de détention des associés avec 100%
        let total = 0;
        if (this.associateUsersTotalShares.sharePercentage) {
            total = 100 - this.associateUsersTotalShares.sharePercentage;
        }
        return total + " %";
    }

    get sciShareQuantityDifference() {
        // Compare la somme des parts des associés avec le nombre total de parts de la société
        let total = 0;
        if (this.shareTotal && this.sciAssociateUsersTotalShares.shareQuantity) {
            total = this.shareTotal - this.sciAssociateUsersTotalShares.shareQuantity;
        }
        return total;
    }

    get sciSharePercentageDifference() {
        // Compare la somme des pourcentages de détention des associés avec 100%
        let total = 0;
        if (this.sciAssociateUsersTotalShares.sharePercentage) {
            total = 100 - this.sciAssociateUsersTotalShares.sharePercentage;
        }
        return total + " %";
    }

    // get totalDetentionAmount() {
    //     let total = 0

    //     if (this.associateUsers) {
    //         this.associateUsers.forEach(
    //             user => total += (user.investment as any).amount
    //         )

    //         return total + " %"
    //     }

    //     return null
    // }
    get associateUsersTotalShares() {
        let shareQuantity = 0;
        let sharePercentage = 0;

        if (this.associateUsers) {
            this.associateUsers.forEach((user) => {
                if (user.investment && user.investment.capitalShare) {
                    shareQuantity += user.investment.capitalShare;
                }
                if (user.investment && user.investment.amount) {
                    sharePercentage += user.investment.amount; // le % est stocké dans amount -> Correction à envisager
                }
                // if (user.investment && user.investment.sharesPercentage?.length) {
                //     let sharesPercentage = user.investment.sharesPercentage;
                //     for (let share of sharesPercentage) {
                //         if (share.percentage) {
                //             shareAmount += share.percentage;
                //         }
                //         if (share.quantity) {
                //             shareQuantity += share.quantity;
                //         }
                //     }
                // }
            });
        }

        return { shareQuantity, sharePercentage };
    }

    get sciAssociateUsersTotalShares() {
        let shareQuantity = 0;
        let sharePercentage = 0;

        if (this.sciAssociateUsers) {
            this.sciAssociateUsers.forEach((user) => {
                if (user.investment && user.investment.shares && user.investment.shares.length) {
                    const shares = user.investment.shares;
                    for (const share of shares) {
                        if (share.quantity) {
                            shareQuantity += share.quantity;
                        }
                        if (share.percentage) {
                            sharePercentage += share.percentage;
                        }
                    }
                }
            });
        }

        return { shareQuantity, sharePercentage };
    }

    get associateUsers() {
        // Fix to avoid double entries in the list of associates
        if (!this.company?.companyUsers?.length) return [];

        const associateUsers = this.company.companyUsers.filter(
            (user) => user?.investment && (user.investment.capitalShare || user.investment.amount),
        );

        const uniqueUsersMap = new Map();

        for (const user of associateUsers) {
            const id = user?.id;
            if (id && !uniqueUsersMap.has(id)) {
                uniqueUsersMap.set(id, user);
            }
        }

        return Array.from(uniqueUsersMap.values());
    }

    get sciAssociateUsers() {
        const sciAssociateUsers =
            this.company?.companyUsers.filter(
                (user) => user.investment !== null && user.investment.shares !== null,
            ) || [];
        return sciAssociateUsers;
    }

    formatUserType(user) {
        if (user && user.type) {
            if (user.type === "NATURAL_PERSON") {
                return "Personne Physique";
            } else {
                return "Personne Morale";
            }
        } else {
            return "-";
        }
    }

    formatUserFirstname(user) {
        if (user && user.firstname) {
            return user.firstname;
        } else {
            return "-";
        }
    }

    formatUserLastname(user) {
        if (user && user.lastname) {
            return user.lastname;
        } else {
            return "-";
        }
    }

    formatDate(date) {
        if (!date) return "";
        moment.locale("fr");
        return moment(date).format("DD/MM/YYYY");
    }

    formatCapital(capital) {
        if (!capital) return "";
        return capital + " €";
    }

    formatPercentage(percentage) {
        if (!percentage) return "";
        return percentage + " %";
    }
}

export default toNative(AssociatesTable);
</script>
